<ng-template #content let-d="dismiss" data-backdrop="static" data-keyboard="false">
  <div class="row" *ngIf="isloading">
    <div class="col-md-12">
      <div class="loader animation-start">
        <span class="circle delay-1 size-2"></span>
        <span class="circle delay-2 size-4"></span>
        <span class="circle delay-3 size-6"></span>
        <span class="circle delay-4 size-7"></span>
        <span class="circle delay-5 size-7"></span>
        <span class="circle delay-6 size-6"></span>
        <span class="circle delay-7 size-4"></span>
        <span class="circle delay-8 size-2"></span>
      </div>
    </div>
  </div>
  <div *ngIf="!isloading">
    <div class="modal-header capability-modal-header">
      <h4 class="modal-title" id="modal-basic-title">Select your manufacturing capabilities</h4>
      <button type="button" class="close capability-close-btn" aria-label="Close" (click)="d('notNow');setCapability(1);">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body capability-modal-body">
      <div class="row">
        <div class="col-md-12 text-left capability-helper-text">
          You currently don’t have any capabilities selected for your business profile. Selecting a few of these
          can help us more accurately match buyers to your needs.
        </div>
      </div>
      <div class="row m-t-15 text-left">
        <div class="col-md-6">
          Select capabilities
        </div>
        <div class="col-md-6 Deselect-All text-right" (click)="processDeSelectAll()">
          Deselect All
        </div>

      </div>
      <div class="row capability-lists-row">
        <div class="col-md-5 p-r-0">
          <div class="Rectangle-indi manufac_scroll p-10 capability-list-panel">
            <div
              *ngFor="let singlePart of iCustomProcessViewModelOriColl | groupBy:'parentDisciplineName';let iPart = index;">
              <ul>
                <li class="Main-Topic" [class.active]="(getChildProcess(singlePart.key).length ==
                   getSelectedChildProcess(singlePart.key).length)"
                  *ngIf="singlePart.key !== 'Let MFG.com Pick the Best Category'"
                  (click)="processAddAllToSelection(singlePart.key)">{{singlePart.key}}</li>
                <li class="Subtopic-1-Subtopic" *ngFor="let child of getChildProcess(singlePart.key)"
                  (click)="processAddToSelection(child.childDisciplineId)">
                  <label
                    [class.active]="selectedProcess(singlePart.key) && selectedChildProcess(child.childDisciplineId)"
                    *ngIf="child.childDisciplineName !== 'Let MFG.com Pick the Best Category'">
                    {{child.childDisciplineName}}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-2 p-l-0 p-r-0 capability-transfer-col">
          <i class="fa fa-exchange" aria-hidden="true"></i>
        </div>
        <div class="col-md-5 p-l-0">
          <div class="Rectangle-indi manufac_scroll p-10 capability-list-panel">
            <div *ngIf="!selectedProcessParent.length">
              <span class="f-14 capability-placeholder-text">
                Click main topics to add the whole group, subtopics to add one at a time
              </span>
            </div>
            <div *ngIf="selectedProcessParent.length">
              <div *ngFor="let singlePart of selectedProcessParent">
                <ul>
                  <li class="Main-Topic" (click)="processRemoveALLFromSelection(singlePart.key)">{{singlePart.key }}
                  </li>
                  <li class="Subtopic-1-Subtopic" *ngFor="let child of getSelectedChildProcess(singlePart.key)"
                    (click)="processRemoveFromSelection(child.schildDisciplineId)">
                    {{child.schildDisciplineName}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer capability-modal-footer">
      <button type="button" class="btn btn-cancel capability-btn capability-btn-secondary" (click)="d('notNow');setCapability(1);">I’ll Do
        This Later</button>
      <button type="button" class="btn btn-save capability-btn capability-btn-primary" [disabled]="!selectedProcessParent.length"
        (click)="d('save');setCapability(2);">Save Capabilities</button>
    </div>
  </div>
</ng-template>
